import { render, staticRenderFns } from "./CorreccionPagos.vue?vue&type=template&id=0e8e9670&scoped=true&"
import script from "./CorreccionPagos.vue?vue&type=script&lang=js&"
export * from "./CorreccionPagos.vue?vue&type=script&lang=js&"
import style0 from "./CorreccionPagos.vue?vue&type=style&index=0&id=0e8e9670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8e9670",
  null
  
)

export default component.exports